import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HubIcon from '@mui/icons-material/Hub';

const Navbar = () => {
  return (
    <AppBar position="sticky">
      <Toolbar>
        <DeveloperBoardIcon sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          PikaGPU
        </Typography>
        <Box>
          <Button 
            color="inherit" 
            component={RouterLink} 
            to="/" 
            startIcon={<DashboardIcon />}
            sx={{ mr: 1 }}
          >
            Dashboard
          </Button>
          <Button 
            color="inherit" 
            component={RouterLink} 
            to="/clusters" 
            startIcon={<HubIcon />}
          >
            Clusters
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 